<template>
  <div class="flex-center position-relative w100">
    <div class="container-fluid">
    </div>
    <div class="influencer-wrapper">
      <el-col :xs="24" :sm="9" :md="8" :lg="6" :xl="6"
       v-for="item in influencers" :key="item.id">
        <el-card shadow="hover">
          <div class="card-container">
            <img class="round" src="@/assets/images/jimmy.jpg" />
            <h3>{{item.name}}</h3>
            <p>{{item.country}}</p>
            <div class="buttons">
              <el-button class="btn-main-sm" type="primary">View profile</el-button>
            </div>
            <ul>
              <li>
                <strong>{{item.subscribers}}</strong>
                <small>Subscribers</small>
              </li>
              <li>
                <strong>{{item.posts}}</strong>
                <small>Videos</small>
              </li>
            </ul>
          </div>
        </el-card>
      </el-col>
    </div>
    <div class="filter-wrapper">
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart,
  },

  computed: {},

  methods: {},

  data() {
    return {
      influencers: [
        {
          id: 1,
          img: 'jimmy.jpg',
          name: 'Jimmy Channel',
          country: 'New York',
          subscribers: '46K+',
          posts: '1244'
        },
        {
          id: 2,
          img: 'jimmy.jpg',
          name: 'Jimmy Channel',
          country: 'New York',
          subscribers: '46K+',
          posts: '1244'
        },
        {
          id: 3,
          img: 'jimmy.jpg',
          name: 'Jimmy Channel',
          country: 'New York',
          subscribers: '46K+',
          posts: '1244'
        },
        {
          id: 4,
          img: 'jimmy.jpg',
          name: 'Jimmy Channel',
          country: 'New York',
          subscribers: '46K+',
          posts: '1244'
        },
        {
          id: 5,
          img: 'jimmy.jpg',
          name: 'Jimmy Channel',
          country: 'New York',
          subscribers: '46K+',
          posts: '1244'
        },
        {
          id: 6,
          img: 'jimmy.jpg',
          name: 'Jimmy Channel',
          country: 'New York',
          subscribers: '46K+',
          posts: '1244'
        }
      ]
    }
  },
}
</script>

<style lang="scss" scoped>

.container-fluid {
  height: calc(100vh - 88px);
  margin: 0;
  top: 86px;
  right: 0;
  width: 18%;
  position: fixed;
  overflow: hidden;
  background: #c4c2cb;
}

.filter-wrapper {
  width: 22%;
  float: right;
  height: 80vh;
}

.influencer-wrapper {
  width: 78%;
  .card-container {
    padding: 10px 12px;
    position: relative;
    text-align: center;
    &:before {
      content: '';
      position: absolute;
      top: -4rem;
      left: -1.3rem;
      width: 132%;
      height: 7rem;
      transform: skewY(348deg);
      background: #124f921c;
    }
    h3 {
      margin: 7px 0 0;
    }
    p {
      font-size: 14px;
      margin: 2px;
    }
    .round {
      border: 7px solid #fff;
      position: relative;
      border-radius: 50%;
      width: 6rem;
    }
    ul {
      list-style-type: none;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 16px 0 0;
      margin: 0;
      li {
        display: grid;
        padding: 0 20px;
        strong {
          font-size: 19px;
          font-weight: bold;
        }
        small {
          font-size: 14px;
        }
      }
    }
    .buttons {
      padding: 15px 0;
      border-bottom: 1px solid #e6e6e6;
    }
  }
}

@media screen and (max-width: 1199px) {
  .container-fluid, .filter-wrapper {
    display: none;
  }
  .influencer-wrapper {
    width: 100%
  }
}

</style>